var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.331 6.15445C11.6511 5.74045 10.8544 5.49993 10.0003 5.49993C9.14633 5.49993 8.34982 5.74031 7.67012 6.1541L6.32582 4.80979C5.89536 4.37933 5.94539 3.6619 6.48269 3.37571C7.5317 2.81696 8.72893 2.5 10.0004 2.5C11.2721 2.5 12.4694 2.81705 13.5186 3.37595C14.0558 3.66217 14.1058 4.37958 13.6754 4.81003L12.331 6.15445Z",
    fill: "#7E86A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8459 7.66993L15.1903 6.32554C15.6208 5.89506 16.3382 5.9451 16.6244 6.48243C17.1831 7.53144 17.5 8.72866 17.5 10.0001C17.5 11.2716 17.1831 12.4686 16.6245 13.5175C16.3383 14.0548 15.6208 14.1049 15.1904 13.6744L13.846 12.33C14.2597 11.6504 14.5001 10.8539 14.5001 10.0001C14.5001 9.14613 14.2596 8.34962 13.8459 7.66993Z",
    fill: "#7E86A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3308 13.8452L13.6751 15.1896C14.1055 15.62 14.0556 16.3373 13.5184 16.6236C12.4691 17.1828 11.2714 17.5 9.99937 17.5C8.72816 17.5 7.53121 17.1832 6.48236 16.6246C5.94499 16.3385 5.89491 15.621 6.32541 15.1905L7.66977 13.8461C8.3494 14.2598 9.14575 14.5001 9.99953 14.5001C10.8539 14.5001 11.6508 14.2594 12.3308 13.8452Z",
    fill: "#7E86A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81031 13.6752C4.37987 14.1056 3.6625 14.0557 3.37624 13.5184C2.81718 12.4692 2.5 11.2717 2.5 9.99984C2.5 8.72797 2.8171 7.53055 3.3761 6.48136C3.66234 5.94411 4.37974 5.89412 4.81018 6.32457L6.15458 7.66898C5.74057 8.34887 5.4999 9.14565 5.4999 9.99993C5.4999 10.8542 5.74056 11.651 6.15459 12.3309L4.81031 13.6752Z",
    fill: "#7E86A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.7a532372da636691cf02c735014d19fd.svg";
export { ForwardRef as ReactComponent };